import React from 'react';
import { Link } from 'react-router-dom';
import CelestialLayout from '../components/celestial/CelestialLayout';
import TopNav from '../components/celestial/TopNav';
import SiteFooter from '../components/celestial/SiteFooter';
import MaterialIcon from '../components/celestial/MaterialIcon';

const STORE_LINKS = {
  googlePlay: 'https://play.google.com/store/apps/details?id=com.astroai.astroapp&hl=tr',
  appStore: 'https://apps.apple.com/app/astro-ai/id000000000',
};

const FEATURES = [
  {
    icon: 'auto_awesome',
    title: 'Burç haritası',
    text: 'Doğum bilgilerinize göre kişiselleştirilmiş astroloji haritası ve AI yorumları.',
  },
  {
    icon: 'style',
    title: 'Tarot okumaları',
    text: 'Tek kart veya açılımlarla tarot çekimi ve anlamlı yorumlar.',
  },
  {
    icon: 'calendar_month',
    title: 'Günlük içerik',
    text: 'Astrolojik olaylar, ay evreleri ve kişisel günlük özetler.',
  },
] as const;

export default function Home() {
  return (
    <CelestialLayout>
      <TopNav />
      <div className="celestial-main">
        <section className="celestial-hero celestial-container">
          <h1 className="celestial-display">
            <span className="celestial-gradient-text">Astro Social</span>
            {' '}
            ile hayatını keşfet
          </h1>
          <p className="celestial-body-lg" style={{ maxWidth: '42rem', marginBottom: '1rem' }}>
            Kişiselleştirilmiş astroloji haritaları, tarot okumaları ve günlük yorumlarla
            kendinizi ve geleceğinizi keşfedin.
          </p>
          <p className="celestial-caption" style={{ marginBottom: '2rem' }}>
            Mobil uygulama · Google Play ve App Store
          </p>
          <div className="celestial-store-row">
            <a
              href={STORE_LINKS.googlePlay}
              target="_blank"
              rel="noopener noreferrer"
              className="celestial-store-btn celestial-store-btn--secondary"
              aria-label="Google Play'den indir"
            >
              <MaterialIcon name="play_arrow" size={28} />
              <span className="celestial-store-btn__meta">
                <span className="celestial-store-btn__small">GET IT ON</span>
                <span className="celestial-store-btn__label">Google Play</span>
              </span>
            </a>
            <a
              href={STORE_LINKS.appStore}
              target="_blank"
              rel="noopener noreferrer"
              className="celestial-store-btn celestial-store-btn--primary"
              aria-label="App Store'dan indir"
            >
              <MaterialIcon name="phone_iphone" size={28} />
              <span className="celestial-store-btn__meta">
                <span className="celestial-store-btn__small">Download on the</span>
                <span className="celestial-store-btn__label">App Store</span>
              </span>
            </a>
          </div>
        </section>

        <section className="celestial-features">
          <div className="celestial-container">
            <h2 className="celestial-headline-xl celestial-text-center" style={{ marginBottom: '4rem' }}>
              Neler sunuyoruz?
            </h2>
            <div className="celestial-features__grid">
              {FEATURES.map((f) => (
                <article key={f.title} className="celestial-glass celestial-feature-card">
                  <div className="celestial-icon-box">
                    <MaterialIcon name={f.icon} filled size={26} />
                  </div>
                  <h3>{f.title}</h3>
                  <p>{f.text}</p>
                </article>
              ))}
            </div>
            <p className="celestial-text-center" style={{ marginTop: '2.5rem' }}>
              <Link to="/icerikler" className="celestial-btn-secondary">
                Tüm içerikler ve özellikler
                <MaterialIcon name="arrow_forward" size={18} />
              </Link>
            </p>
          </div>
        </section>
      </div>
      <SiteFooter />
    </CelestialLayout>
  );
}
